export default __webpack_public_path__ + "static/ptt-aaaafd9a7c62ee8c0baca32a40580062.png";